import Tabs from "components/tabs";
import Supplier from "pages/master-data/suppliers/supplier";
import SupplierGroup from "pages/master-data/suppliers/supplier-group";
import intl from "react-intl-universal";

const MasterSupplier = () => {
  const supplierScreen = [
    {
      key: 1,
      label: intl.get("master-data.suppliers.ableSupplier.header.title"),
      content: <Supplier />
    },
    {
      key: 2,
      label: intl.get("master-data.suppliers.usersGroupSupplier.header.title"),
      content: <SupplierGroup />
    }
  ];
  
  return (
    <Tabs
      tabsContent={supplierScreen}
    />
  );
};

export default MasterSupplier;
